import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IconButton, Tooltip } from '@material-ui/core';
import { SaveAlt } from '@material-ui/icons';
import { get } from 'lodash/fp';
import { saveAs } from 'file-saver';

const S = {
  Tooltip: styled(({ classes, className, ...otherProps }) => (
    <Tooltip
      className={className}
      classes={{
        ...classes,
        popper: className,
        tooltip: 'tooltip',
      }}
      {...otherProps}
    />
  ))`
    .tooltip {
      position: relative;
      padding: 6px 16px;
      background-color: ${({ theme }) => theme.palette.grey[700]};
    }
    .tooltip::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 100%);
      border: 5px solid transparent;
      border-top: 7px solid ${({ theme }) => theme.palette.grey[700]};
    }
  `,
  SaveAlt: styled(SaveAlt)`
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: 1.25rem;
  `,
};

const PDFDownloadLink = ({ className, newsletter }) => {
  const downloadPDF = useCallback(() => {
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(
        new Blob([get('blob', newsletter.data)], { type: 'application/pdf;charset=utf-8' }),
        `${get('title', newsletter.data)}.pdf`,
      );
    }

    if (!navigator.msSaveOrOpenBlob) {
      saveAs(
        new Blob([get('blob', newsletter.data)], { type: 'application/pdf;charset=utf-8' }),
        get('title', newsletter.data),
      );
    }
  }, [newsletter.data]);

  return (
    !newsletter.loading && (
      <S.Tooltip title="PDF 다운로드" placement="top">
        <IconButton className={className} type="button" size="small" onClick={downloadPDF}>
          <S.SaveAlt />
        </IconButton>
      </S.Tooltip>
    )
  );
};

PDFDownloadLink.propTypes = {
  className: PropTypes.string,
  newsletter: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

PDFDownloadLink.defaultProps = {
  className: undefined,
};

export default PDFDownloadLink;
